import RecommendedPanel from 'src/components/ConnectedVehicle/RecommendedPanel/RecommendedPanel';
import { connect } from 'react-redux';
import { IStoreState } from 'src/store';
import { ConnectedVehicleActionCreator } from 'src/store/states';

const mapStateToProps = (state: IStoreState) => ({
    connectedVehicle: state.ConnectedVehicle.ConnectedVehicleRec,
    checkedRecommended: state.ConnectedVehicle.CheckedRecommended,
    importedRecommended: state.ConnectedVehicle.ImportedRecommended,
    mode: state.Framework.specProfile,
});

const mapDispatchToProps = {
    toggleRecommended: ConnectedVehicleActionCreator.ToggleRecommended,
};

export default connect(mapStateToProps, mapDispatchToProps)(RecommendedPanel);